import { Timestamp } from '@b2b/types/core';
import angular from 'angular';

export class SubscriptionsListService {
  static $inject = [];

  private calendar: { startDate: Timestamp | Date; endDate: Timestamp | Date } = {
    startDate: '',
    endDate: '',
  };

  init() {
    this.calendar.startDate = this.getLastSixtyDays();
    this.calendar.endDate = this.getToday();
  }

  getToday() {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;

  }

  getLastSixtyDays() {
    const date = new Date();
    
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);

    return new Date(new Date().setDate(date.getDate() - 60));
  }

  getStartDate() {
    return this.calendar.startDate;
  }

  getEndDate() {
    return this.calendar.endDate;
  }

  setStartDate(startDate) {
    this.calendar.startDate = startDate;
  }

  setEndDate(endDate) {
    this.calendar.endDate = endDate;
  }
}

export const SubscriptionsListServiceModule = angular
  .module('acme.view.application.subscriptions.list.service', [])

  .service('SubscriptionsListService', SubscriptionsListService).name;
